import {CALCULATOR_SETTINGS} from 'client/Assignments/constants';
import type {CalculatorSetting, CalculatorTier} from 'client/Assignments/constants';

import type {CalculatorType} from './CalculatorTitleBar.react';

/** Calculator tiers from least to most capable; each one allows every tier below it. */
export const TIER_ORDER: readonly CalculatorTier[] = ['none', 'basic', 'scientific', 'graphing'];

const asTier = (value: unknown): CalculatorTier => {
  const tier = typeof value === 'string' ? value.toLowerCase() : '';
  return TIER_ORDER.find((known) => known === tier) ?? 'none';
};

/**
 * The calculator a student gets on a question. A teacher's named setting holds every question to
 * that tier; following content, or having no setting at all, uses the question's own content tier.
 * Anything unrecognised resolves to `none`.
 */
export function resolveCalculatorTier(
  setting: CalculatorSetting | undefined,
  contentTier: unknown
): CalculatorTier {
  if (setting && setting !== CALCULATOR_SETTINGS.FOLLOW_CONTENT) {
    return asTier(setting);
  }
  return asTier(contentTier);
}

/** The tier for practice with no teacher setting: the question's own designation, else its content. */
export function resolveContentCalculatorTier({
  questionTier,
  contentTier
}: {
  questionTier: string | null | undefined;
  contentTier: unknown;
}): CalculatorTier {
  return asTier(questionTier || contentTier);
}

/** The calculators a tier offers: the tier itself and every simpler one. */
export function calculatorTypesFor(tier: CalculatorTier): CalculatorType[] {
  return TIER_ORDER.slice(1, TIER_ORDER.indexOf(tier) + 1) as CalculatorType[];
}
